import React, { useState } from 'react'
import { Box } from 'theme-ui'
import Navigation from '@components/Navigation'
import Drawer from '@components/Drawer'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'

const styles = {
  desktopMenu: {
    display: [`none`, `none`, `none`, `none`]
  },
  mobileMenu: {
    display: [`block`, `block`, `block`, `block`],
    ml: [`1rem`, `1rem`, `1rem`, `1rem`]
  },
  desktopMenuWrapper: {
    justifyContent: 'flex-end'
  }
}

export const HeaderMenu = ({ mobileMenu = {} }) => {
  const { headerMenu} = useSiteMetadata()
  const [open, setOpen] = useState(false)
  
  const handleSwitch = () => {
    setOpen(!open)
  }

  const resourcesMenu = [
    {
      id: 'menu1',
      name: 'Pope Francis and Francis of Assisi',
      slug: '/pope-francis-and-francis-of-assisi'
    },
    {
      id: 'menu2',
      name: 'Heritage Series',
      slug: '/resources/heritage-series'
    },
    {
      id: 'menu3',
      name: 'Symposium Series',
      slug: '/resources/symposium-series'
    },
    {
      id: 'menu4',
      name: 'Franciscan Connections',
      slug: 'https://www.franciscanconnections.com/'
    },
    {
      id: 'menu5',
      name: 'Custodians of the Tradition',
      slug: '/CustodiansOfTheTradition'
    },
    {
      id: 'menu6',
      name: 'Videos',
      slug: '/videos'
    },
    {
      id: 'menu7',
      name: 'Other Resources',
      slug: '/other-resources'
    }
  ]

  const headerMenuMobile = [
    ...headerMenu,
  ]

  const desktopMenuNav = (
    <>
      <Navigation
        variant='horizontal'
        items={headerMenu}
        wrapperStyle={styles.desktopMenuWrapper}
      />
    </>
  )

  const mobileMenuNav = (
    <Drawer
     open={open} 
     setOpen={setOpen} 
     handleSwitch={handleSwitch}>
      <Navigation
        variant='vertical'
        headingProps={{ variant: 'h3' }}
        callFrom='Navbar'
        setOpen={setOpen}
        items={[
          {
            title: 'Main Menu',
            items: headerMenuMobile
          }
          // {
          //   title: 'Resources',
          //   items: resourcesMenu
          // },
          // {
          //   title: 'About',
          //   items: [
          //     {
          //       id: 'menu1',
          //       name: 'Who we are',
          //       slug: '/about/#who-we-are'
          //     },
          //     {
          //       id: 'menu2',
          //       name: 'What we do',
          //       slug: '/about/#what-we-do'
          //     },
          //     {
          //       id: 'menu2',
          //       name: 'Board Members',
          //       slug: '/about/#board-members'
          //     }
          //   ]
          // }
          // mobileMenu
        ]}
      />
    </Drawer>
  )

  return (
    <>
      <Box sx={styles.desktopMenu}>{desktopMenuNav}</Box>
      <Box sx={styles.mobileMenu}>{mobileMenuNav}</Box>
    </>
  )
}
